import SelectTokensView from './select-tokens-view';
import RaceSettingsView from './race-settings-view';
import VictoryMetricsAndEdgeView from './victory-metrics-and-edge-view';

import { RaceData, Token } from '@/pages/race-wizard';

const StepViewBoard = ({
  title,
  subTitle,
  children,
}: {
  children?: React.ReactNode;
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
}) => {
  return (
    <div className="space-y-8 overflow-hidden rounded-3xl border border-[#282133] bg-[#10091C] px-6 py-8 lg:px-10">
      <div className="space-y-1">
        <div className="text-[20px] font-bold">{title}</div>
        <div className="text-xs text-[#9C9C9C]">{subTitle}</div>
      </div>
      {children}
    </div>
  );
};

const StepViews = (props: {
  currentStep: number;
  totalSteps: number;
  isLastStep: boolean;
  tokens: Token[];
  initialRaceSettings: RaceData;
  onBack: () => void;
  onNext: (data: Partial<RaceData>) => void;
}) => {
  const currentStep = props.currentStep;

  if (currentStep === 1) {
    return (
      <StepViewBoard title="Select Tokens" subTitle="Pick tokens to include in the race">
        <SelectTokensView {...props} />
      </StepViewBoard>
    );
  }

  if (currentStep === 2) {
    return (
      <StepViewBoard title="Race Settings">
        <RaceSettingsView {...props} />
      </StepViewBoard>
    );
  }

  if (currentStep === 3) {
    return (
      <StepViewBoard title="Define Victory Metric & Edge">
        <VictoryMetricsAndEdgeView {...props} />
      </StepViewBoard>
    );
  }

  return null;
};

export default StepViews;
